import { registerPlugin } from '@capacitor/core';
const HealthSteps = registerPlugin('HealthSteps', {
    web: () => import('./web').then((m) => new m.HealthStepsWeb()),
});
export * from './definitions';
export { HealthSteps };
